import { useState, useEffect } from 'react'
import { imagesApi, CollectionImage } from '../services/api'

export const useCollectionImages = (collection: 'boys' | 'girls') => {
  const [images, setImages] = useState<CollectionImage[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const loadImages = async () => {
      try {
        setIsLoading(true)
        setError(null)
        
        const response = await imagesApi.getByCollection(collection)
        if (response.success && response.data) {
          setImages(response.data)
        }
      } catch (err) {
        console.error(`Error al cargar imágenes de ${collection}:`, err)
        setError('Error al cargar las imágenes')
        // Mantener array vacío en caso de error
        setImages([])
      } finally {
        setIsLoading(false)
      }
    }

    loadImages()
  }, [collection])

  return { images, isLoading, error }
}
